import {InjectionToken} from '@angular/core';
import {IAppConfig} from '../interfaces';

export const APP_CONFIG = new InjectionToken<IAppConfig>('Application config');
